import dayjs from "dayjs";
import { type WithTranslation } from "react-i18next";
import { type ReactNode } from "react";

type PredefinedDropdownChoices = { label: ReactNode; value: PredefinedDate }[];

export enum PredefinedDate {
  ALL_TIME,
  LAST_7_DAYS,
  LAST_30_DAYS,
  PAST_6_MONTHS,
  CURRENT_YEAR,
  PAST_1_YEAR,
  PAST_2_YEARS,
}

let predefinedDates: PredefinedDropdownChoices | null = null;

export const getPredefinedDatesDropdownOptions: (t: WithTranslation["t"]) => PredefinedDropdownChoices = (t) => {
  if (!predefinedDates) {
    predefinedDates = generatePredefinedDatesDropdownOptions(t);
  }
  return predefinedDates;
};

const generatePredefinedDatesDropdownOptions = (t: WithTranslation["t"]) => {
  const year = new Date().getFullYear();

  return [
    {
      label: t("orderListPage.predefinedDate.allTime"),
      value: PredefinedDate.ALL_TIME,
    },
    {
      label: t("orderListPage.predefinedDate.last7Days"),
      value: PredefinedDate.LAST_7_DAYS,
    },
    {
      label: t("orderListPage.predefinedDate.last30Days"),
      value: PredefinedDate.LAST_30_DAYS,
    },
    {
      label: t("orderListPage.predefinedDate.past6Months"),
      value: PredefinedDate.PAST_6_MONTHS,
    },
    {
      label: t("orderListPage.predefinedDate.currentYear", { year }),
      value: PredefinedDate.CURRENT_YEAR,
    },
    {
      label: t("orderListPage.predefinedDate.past1Year", { year: year - 1 }),
      value: PredefinedDate.PAST_1_YEAR,
    },
    {
      label: t("orderListPage.predefinedDate.past2Years", { year: year - 2 }),
      value: PredefinedDate.PAST_2_YEARS,
    },
  ];
};

export function getPredefinedPeriodDates(predefinedOption: PredefinedDate): { dateFrom?: Date; dateTo?: Date } {
  switch (predefinedOption) {
    case PredefinedDate.ALL_TIME: {
      return {};
    }

    case PredefinedDate.LAST_7_DAYS: {
      return {
        dateFrom: dayjs().add(-7, "day").toDate(),
      };
    }

    case PredefinedDate.LAST_30_DAYS: {
      return {
        dateFrom: dayjs().add(-30, "day").toDate(),
      };
    }

    case PredefinedDate.PAST_6_MONTHS: {
      return {
        dateFrom: dayjs().startOf("month").add(-6, "month").toDate(),
      };
    }

    case PredefinedDate.CURRENT_YEAR: {
      return {
        dateFrom: dayjs().startOf("year").toDate(),
        dateTo: dayjs().endOf("year").toDate(),
      };
    }

    case PredefinedDate.PAST_1_YEAR: {
      return {
        dateFrom: dayjs().add(-1, "year").startOf("year").toDate(),
      };
    }

    case PredefinedDate.PAST_2_YEARS: {
      return {
        dateFrom: dayjs().add(-2, "year").startOf("year").toDate(),
      };
    }

    default: {
      return {};
    }
  }
}
